import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "col span-6 cluster-deployment-settings-input" }
const _hoisted_4 = {
  key: 0,
  class: "sub-description"
}
const _hoisted_5 = { class: "col span-6 cluster-deployment-settings-input" }
const _hoisted_6 = {
  key: 0,
  class: "sub-description"
}

import { useStore } from 'vuex';
import { useI18n } from '@shell/composables/useI18n';
import LabeledInput from '@components/Form/LabeledInput/LabeledInput.vue';
import { RcIcon } from '@components/RcIcon';
import { getBundleDeploymentOptionsDocsUrl } from '@shell/utils/fleet-docs';


export default /*@__PURE__*/_defineComponent({
  __name: 'HelmOpTargetOptionsSection',
  props: {
    value: {},
    mode: {},
    compact: { type: Boolean, default: false }
  },
  setup(__props: any) {



const store = useStore();
const { t } = useI18n(store);

const DOCS_URL = getBundleDeploymentOptionsDocsUrl();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ row: !__props.compact, 'col gap-md': __props.compact }),
    "data-testid": "helmop-target-options-section"
  }, [
    (__props.compact)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
          _createTextVNode(_toDisplayString(_unref(t)('fleet.helmOp.target.clusterDeploymentDescription')), 1),
          _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_unref(t)('generic.learnMoreAbout')) + " ", 1),
          _createElementVNode("a", {
            href: _unref(DOCS_URL),
            target: "_blank",
            rel: "noopener noreferrer nofollow"
          }, [
            _createTextVNode(_toDisplayString(_unref(t)('fleet.helmOp.target.clusterDeploymentLink')) + " ", 1),
            _createVNode(_unref(RcIcon), {
              type: "external-link",
              size: "small",
              "aria-hidden": "true"
            })
          ], 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    _cache[5] || (_cache[5] = _createTextVNode()),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(LabeledInput, {
        value: __props.value.spec.serviceAccount,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((__props.value.spec.serviceAccount) = $event)),
        mode: __props.mode,
        "label-key": "fleet.helmOp.serviceAccount.label",
        "placeholder-key": __props.compact ? 'fleet.helmOp.serviceAccount.compactPlaceholder' : 'fleet.helmOp.serviceAccount.placeholder',
        "data-testid": "helmop-target-options-service-account"
      }, null, 8, ["value", "mode", "placeholder-key"]),
      _cache[3] || (_cache[3] = _createTextVNode()),
      (__props.compact)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(t)('fleet.helmOp.serviceAccount.compactDescription')), 1))
        : _createCommentVNode("", true)
    ]),
    _cache[6] || (_cache[6] = _createTextVNode()),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(LabeledInput, {
        value: __props.value.spec.namespace,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((__props.value.spec.namespace) = $event)),
        mode: __props.mode,
        "label-key": "fleet.helmOp.targetNamespace.label",
        "placeholder-key": __props.compact ? 'fleet.helmOp.targetNamespace.compactPlaceholder' : 'fleet.helmOp.targetNamespace.placeholder',
        "data-testid": "helmop-target-options-namespace"
      }, null, 8, ["value", "mode", "placeholder-key"]),
      _cache[4] || (_cache[4] = _createTextVNode()),
      (__props.compact)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_unref(t)('fleet.helmOp.targetNamespace.compactDescription')), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})